<sw-page class="topdata-conversion-log-list">
    <template #smart-bar-header>
        <h2>{{ $tc('TopdataContactLoginSW6.conversionLog.list.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button variant="primary" @click="getList">
            {{ $tc('global.default.refresh') }}
        </sw-button>
    </template>

    <template #content>
        <div class="topdata-conversion-log-list__toolbar">
            <sw-text-field
                v-model="emailSearchTerm"
                class="topdata-conversion-log-list__search"
                size="small"
                :placeholder="$tc('TopdataContactLoginSW6.conversionLog.list.searchEmailPlaceholder')"
                @input="onEmailSearchInput"
            >
                <template #prefix>
                    <sw-icon name="regular-search" size="16" />
                </template>
            </sw-text-field>

            <sw-select-field
                v-model="filterTriggeredBy"
                class="topdata-conversion-log-list__select"
                size="small"
                :options="triggeredByOptions"
                @change="onFilterChanged"
            />
        </div>

        <sw-entity-listing
            v-if="items"
            :items="items"
            :repository="repository"
            :columns="columns"
            :isLoading="isLoading"
            :sort-by="sortBy"
            :sort-direction="sortDirection"
            :allow-edit="false"
            :allow-delete="false"
            identifier="id"
            @page-change="onPageChange"
        >
            <template #column-triggeredBy="{ item }">
                <sw-badge variant="info">
                    {{ getTriggeredByLabel(item.triggeredBy) }}
                </sw-badge>
            </template>

            <template #column-createdAt="{ item }">
                <sw-time-ago
                    v-if="item.createdAt"
                    :date="item.createdAt"
                    :date-time-format="{ month: '2-digit', day: '2-digit' }"
                />
            </template>
        </sw-entity-listing>
    </template>
</sw-page>
